<template>
  <div class="crewHome">
    <div class="crewHome-content">
      <!-- <el-form :inline="true" :model="formInline" class="other-form-left">
        <el-form-item label="船舶:" style="margin-left: 10px">
          <el-input
            v-model="formInline.shipName"
            style="width: 100px"
            :readonly="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="月份:">
          <el-input
            v-model="formInline.month"
            style="width: 100px"
            :readonly="true"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-form :inline="true" :model="formInline" class="other-form-inline">
        <el-form-item>
          <div class="other-search3" @click="exportExcel()">导出</div>
        </el-form-item>
      </el-form> -->
      <!-- <div style="clear: both"></div>
      <el-divider class="other-divider"></el-divider> -->
      <div class="other-table-energy">
        <el-table
          :data="tableData"
          style="width: 100%"
          header-row-class-name="other-header"
          row-class-name="other-row"
          height="100%"
        >
          <el-table-column
            prop="shipName"
            label="船舶名称"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column prop="shipId" label="MMSI" show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="mealFee"
            label="客餐费标准"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="mealFeeTotal"
            label="客餐费金额"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column prop="reason" label="上船事由" show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="peopleNum"
            label="上船人数"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="onShipDate"
            label="上船日期"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="offShipDate"
            label="离船日期"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="onShipDayNum"
            label="在船天数"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table>
      </div>
      <div class="energy-footer" v-if="excellType == '2'">
        <div class="energy-button1" @click="goback()">返回</div>
        <div class="energy-button2" @click="energySumbit()">核准</div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getSpecialShipGuestMealList,
  specialShipGuestMealSummarizeAudit,
  getSpecialEnergySavingShipDetail,
  // exportEnergyExcel,
} from "@/apis/index";
import { apiJob } from "@/config";
export default {
  data() {
    return {
      formInline: {},
      tableData: [],
      tableData2: [],
      labelVal: "管理费(10%)",
      currentPage1: 1,
      pageNo: "1",
      total: 0,
      pageSize: 100,
      companyVisible: false,
      jobParams: {},
      remendLoading: false,
      diaList: {},
      rules: {
        userState: [
          {
            required: true,
            message: "请选择员工在本派遣机构状态",
            trigger: "blur",
          },
        ],
      },
      excellType: "",
    };
  },
  mounted() {
    this.excellType = this.$route.params.type;
    this.getCrewInfoList();
    // this.getSpecialEnergySavingShipDetail();
  },
  methods: {
    onSubmit() {
      this.pageNo = 1;
      this.getCrewInfoList();
    },
    handleOpen() {},
    handleSizeChange(val) {
      this.pageSize = val;
      this.getCrewInfoList();
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getCrewInfoList();
      // console.log(`当前页: ${val}`);
    },
    choseCom() {
      this.companyVisible = true;
    },
    async getCrewInfoList() {
      let res = await getSpecialShipGuestMealList({
        summarizeId: this.$route.params.id,
        pageSize: this.pageSize,
        pageNo: this.pageNo,
      });
      this.total = res.data.rowCount;
      res.data.resultList.forEach((item) => {
        if (item.onShipDate) {
          item.onShipDate = item.onShipDate.split(" ")[0];
        }
        if (item.offShipDate) {
          item.offShipDate = item.offShipDate.split(" ")[0];
        }
      });
      this.tableData = res.data.resultList;
    },
    async getSpecialEnergySavingShipDetail() {
      let res = await getSpecialEnergySavingShipDetail({
        energySavingShipId: this.$route.params.id,
      });
      this.formInline = res.data || {};
      // console.log(res);
    },

    energySumbit() {
      this.$confirm("确定核准吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 执行删除操作
          this.$message({
            message: "核准成功",
            type: "success",
          });
          this.delList();
          // console.log(scope);
        })
        .catch(() => {});
    },
    async delList() {
      await specialShipGuestMealSummarizeAudit({
        summarizeId: this.$route.params.id,
      });
      this.excellType = "1";
      this.$router.go(-1);
      // console.log(res);
      // this.getCrewInfoList();
    },
    passInvite(scope) {
      this.jobParams = {};
      this.diaList = scope.row;
      this.companyVisible = true;
    },
    rememendCrewPass() {
      if (!this.jobParams.userState) {
        this.$message({
          message: "请选择是否属于本公司",
          type: "error",
        });
        return;
      }
      this.remendLoading = true;
      this.addCrewList();
    },
    goback() {
      this.$router.go(-1);
    },
    exportExcel() {
      // await exportEnergyExcel({
      //   specialEnergySavingShipId: this.$route.params.id,
      // });
      window.open(
        `${apiJob}/exportSpecialEnergySavingUserList/exportExcel?token=${sessionStorage.getItem(
          "agenToken"
        )}&specialEnergySavingShipId=${this.$route.params.id || ""}`
      );
    },

    // async addCrewList() {
    //   let res = await crewAudit({
    //     userState: this.jobParams.userState,
    //     crewType: this.jobParams.crewType,
    //     agentAuditState: "2",
    //     userId: this.diaList.userId,
    //     agentCyAuditId: this.diaList.agentCyAuditId,
    //     userOrigin: "2",
    //   });
    //   if (res.code == 1) {
    //     this.$message({
    //       message: "成功",
    //       type: "success",
    //     });
    //     this.remendLoading = false;
    //     this.companyVisible = false;
    //     this.getCrewInfoList();
    //     // this.$router.push({ name: "邀请船员" });
    //   } else {
    //     this.$message({
    //       message: res.msg,
    //       type: "warning",
    //     });
    //     this.remendLoading = false;
    //     this.companyVisible = false;
    //   }
    //   // console.log(res);
    // },
  },
};
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  width: 0.5em;
  height: 0.5em;
}

/* 隐藏滚动条轨道 */
::-webkit-scrollbar-track {
  background-color: transparent;
}

/* 隐藏滚动条滑块 */
::-webkit-scrollbar-thumb {
  background-color: transparent;
}
</style>
